


import FETCHING from '../../library/fetching'
import DATA_MASTER from '../../library/dataMaster'
import UMUM from '../../library/umum'

export default {
  data() {
    return {

        form : {
            id : '',
            kecamatan_id : '',
            lat : '',
            lng : '',

            unit_kerja : '',
            status : '',
            keterangan : '',

            nama_kecamatan : '',
            nama_des_kel : '',
        },

      kategori_id : '',
      unit_kerja : '',
      unit_kerja_full : '',

      list_data : [],
      list_kecamatan: [],
      list_des_kel: [],

      cari_value: "",
      page_first: 1,
      page_last: 0,
      page_limit : 10,

      page_first1: 1,
      page_last1: 0,
      page_limit1 : 10,
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,
      mdl_lihat : false,
      mdl_foto : false,
      btn_add: false,


      FETCHING : FETCHING,
      DATA_MASTER : DATA_MASTER,
      UMUM : UMUM,

      file_old : "",
      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },
  methods: {


    getView : function(){
      this.cek_load_data = true;
      fetch(this.$store.state.url.URL_POTENSI + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            unit_kerja: this.unit_kerja,
            data_ke: this.page_first,
            cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.cek_load_data = false;
              // console.log(res_data);
      });
    },

    addData : function() {
        fetch(this.$store.state.url.URL_POTENSI + "addData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getView();
      });
    },


    editData : function(){
      fetch(this.$store.state.url.URL_POTENSI + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(idnya, file){
      fetch(this.$store.state.url.URL_POTENSI + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            id : idnya,
            file : file, 
          })
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },

    selectData : function(data){
        this.form.id = data.id;
        this.form.kecamatan_id = data.kecamatan_id;
        this.form.lat = data.lat;
        this.form.lng = data.lng;
        this.form.keterangan = data.keterangan;

        this.form.nama_kecamatan = data.nama_kecamatan;
        this.form.nama_des_kel = data.nama_des_kel;
    },

    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },
        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        autocomplete_kbli: function (val, update) {
          update(() => {
             if (val === '') { }
             else {
                FETCHING.getKBLI(val)
             }
          })
       },

        async awaitFetch(){
          this.$store.state.list_des_kel = await this.DATA_MASTER.getDesKel(this.form.kecamatan_id);
        }


  },

  mounted () {


    var get_profile = JSON.parse(localStorage.profile);
    this.form.unit_kerja = get_profile.profile.unit_kerja;


    this.getView();
    DATA_MASTER.getKecamatan();
  },
}
